<template>
  <div class="row">
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-12">
                  <h5 class="card-title">{{$t('soil_advice')}}</h5>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center">
                  <a class="btn btn-xs text-white" style="background-color:red" @click.prevent="goBack()">
                    <i class="fa fa-backward"></i>
                    {{ $t('back') }}
                  </a>
                </div>
           </div>
        </div>
        <div class="card-body">

           <div class="row">
            <div class="col-md-6">
              <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
              </el-select>
            </div>
          </div>
          <hr>
          <div class="row" v-for="(soil, index) in paginated" :key="index">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

              <div class="card" style="border: 2px solid #FEC04A">
              <div class="card-header text-center">
                <div class="card-title">
                  <h6>{{ soil.Title }}</h6>
                </div>
                <div class="card-text">
                  <p>{{ soil.Description }}</p>
                </div>
              </div>
              <div class="card-body">
                  <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>{{ $t('name') }}</th>
                          <th>{{ $t('IsSufficent') }}</th>
                          <th>{{ $t('OptimumMax') }}</th>
                          <th>{{ $t('OptimumMin') }}</th>
                          <th>{{ $t('order') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, key) in soil.Crops" :key="key">
                          <td>{{ data.Name }}</td>
                          <td>{{ data.IsSufficent }}</td>
                          <td>{{ data.OptimumMax }}</td>
                          <td>{{ data.OptimumMin }}</td>
                          <td>{{ data.Order }}</td>
                        </tr>
                      </tbody>
                  </table>
              </div>
              </div>

            </div>

          </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col-sm-6 pagination-primary">
                  <p class="category">{{ $t('showing') }} {{pagination.from}} {{ $t('to') }} {{pagination.to}} {{ $t('of') }} {{pagination.total}} {{ $t('entries') }}</p>
                </div>
                <div class="col-sm-6">
                  <p-pagination
                    class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total"></p-pagination>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import PPagination from "src/components/UIComponents/Pagination.vue";
export default {
  components:{
    PPagination,
  },
  data() {
    return {
      soilAdvice:this.$route.params.data,
      pagination:{
        perPage: 10,
        perPageOptions: [10, 20, 30, 60, 500, 1000],
        currentPage:1,
        nextPage:'',
        prevPage:'',
        total:'',
        from:'',
        to:'',
        page:'',
      },
    }
  },

  methods: {

    goBack(){
      this.$router.push({ name: "ViewSoilList" });
    },

    paginate(array, length, pageNumber){
        this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
        this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
        this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
        this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
        this.pagination.page = Math.ceil(array.length / length);
        this.pagination.total = array.length;
        return array.slice((pageNumber - 1) * length, pageNumber * length);
    },

  },

  mounted() {
     console.log(this.soilAdvice);
  },

  computed: {
    filterData() {
        let result = this.soilAdvice;
        return result;
    },

    paginated(){
        return this.paginate(this.filterData, this.pagination.perPage, this.pagination.currentPage);
    },

  },

}
</script>
